import type React from 'react';

/** A realistic phone-sized viewport (iPhone 13 logical width 390) for previews. */
export function PhoneFrame({ children, scale = 0.8 }: { children: React.ReactNode; scale?: number }) {
  const w = 390;
  const h = 780;
  return (
    <div style={{ width: w * scale + 24, height: h * scale + 24 }} className="shrink-0">
      <div
        className="relative overflow-hidden rounded-[44px] border-[12px] border-neutral-900 bg-neutral-900 shadow-xl"
        style={{ width: w * scale + 24, height: h * scale + 24 }}
      >
        <div
          className="absolute left-0 top-0 origin-top-left overflow-y-auto bg-white"
          style={{ width: w, height: h, transform: `scale(${scale})` }}
        >
          <div className="mx-auto mt-2 h-6 w-28 rounded-full bg-neutral-900" aria-hidden />
          {children}
        </div>
      </div>
    </div>
  );
}
